import { AutoCompleteExternalOptions, BoolPropertyViewModel, Filter, NNumericPropertyViewModel } from "@nts/std";
import { BigNumber, OrderByType } from "@nts/std/types";
import { OrderBy } from "@nts/std";
import { ExternalDomainModelTypeDecorator, ExternalDomainModelTypeNameDecorator, ExternalViewModel, IdentityTypeDecorator, StringPropertyViewModel } from "@nts/std";
import { ExtendedAvailablePaymentIdentity } from "../domain-models/extended-available-payment.identity";
import { ExtendedAvailablePayment } from "../domain-models/extended-available-payment";
import { PaymentDataViewModel } from "./payment-data.view-model";
import { ReceiptLongOpOrchestratorViewModel } from "./receipt-long-op.orchestrator-view-model";
import { map, Observable } from "rxjs";

@IdentityTypeDecorator(ExtendedAvailablePaymentIdentity)
@ExternalDomainModelTypeDecorator(ExtendedAvailablePayment)
@ExternalDomainModelTypeNameDecorator('ExtendedAvailablePayment')
export class ExtendedAvailablePaymentExtViewModel extends ExternalViewModel<ExtendedAvailablePayment, ExtendedAvailablePaymentIdentity> {

  // tslint:disable-next-line: variable-name
  private _id: NNumericPropertyViewModel<number>;

  get id(): NNumericPropertyViewModel<number> {
    return this.getNNumericPropertyViewModel<number>((value) => { this._id = value; }, this._id, 'id');
  }

  // tslint:disable-next-line: variable-name
  private _description: StringPropertyViewModel;

  get description(): StringPropertyViewModel {
    return this.getStringPropertyViewModel((value) => { this._description = value; }, this._description, 'description');
  }

  private _isCashAdvance: BoolPropertyViewModel;

  public get isCashAdvance(): BoolPropertyViewModel {
    return this.getBoolPropertyViewModel((value) => { this._isCashAdvance = value; }, this._isCashAdvance, 'isCashAdvance');
  }

  override async postInit() {

    await super.postInit();

    this.zoomAddIsEnabled = false;
    this.zoomAddIsVisible = false;
    this.zoomSearchIsEnabled = false;
    this.zoomSearchIsVisible = false;
    this.zoomViewIsEnabled = false;
    this.zoomViewIsVisible = false;

    this.autoCompleteOptions = new AutoCompleteExternalOptions();
    this.autoCompleteOptions.propertySearchList = ['Id', 'Description'];
    this.autoCompleteOptions.orderByPropertyNames = [
      new OrderBy({ propertyName: 'Description', sortType: OrderByType.Ascending })
    ];
    this.additionalOutputProperties = ['Id', 'Description', 'IsCashAdvance'];
  }

  override execExternalList(_languageCode?: string, showCodeInDescription?: boolean, basePlainPascalCaseFixedIdentity?: any, decodeProperties?: string[] | null, orderByPropertyNames?: OrderBy[] | null, additionalFilters?: Filter[] | null, fieldSeparator?: string | undefined): Observable<{ description: string; identity: { [key: string]: string | number | BigNumber; }; all: { [key: string]: string | number | BigNumber; }[]; }[]> {
    return super.execExternalList(
      _languageCode,
      showCodeInDescription,
      basePlainPascalCaseFixedIdentity,
      decodeProperties,
      orderByPropertyNames,
      additionalFilters,
      fieldSeparator
    ).pipe(
      map(result => {
        return result.filter(payments => {

          if (this.parent instanceof PaymentDataViewModel) {
            const ovm = this.externalRetriever as ReceiptLongOpOrchestratorViewModel;
            const currencyRef = ovm.rootViewModel?.params?.expenseData?.currencyRef;
            if (currencyRef && currencyRef?.id?.value && !currencyRef.isDefault.value) {
              const isCashAdvance = payments.all.find(currency =>
                currency['IsCashAdvance']
              );
              const isCashAdvanceValue = isCashAdvance?.['IsCashAdvance'] == 'false' ? false : true;
              return !isCashAdvanceValue;
            }
          }

          return true;
        });
      })
    );
  }
}
